<template>
    <div :class="isPhoneBool ? 'pa-5' : 'pa-10'" class="job-report" style="background-color: white;"
        :style="'max-width: ' + (isPadBool ? (isPhoneBool ? 'calc(100vw - 24px)' : '100vw') : 'calc(100vw - 550px)') + '; min-width: ' + (isPadBool ? '90vw' : '50vw')">
        <v-row no-gutters>
            <v-col>
                <h3 class="my-0">{{ $t('partner.job.order') }} {{ job?.Order?.Id }}</h3>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>

        <v-divider class="mt-4"></v-divider>

        <v-row no-gutters class="pt-5" justify="space-between" id="customer">
            <v-col cols="auto" style="min-width: 150px; max-width: 300px;" :class="isPhoneBool ? 'pb-5' : ''">
                <b>{{ Customer.Id }} {{ Customer.Name }}</b><br>
                <v-container v-if="Address" fluid class="pa-0">
                    <v-row no-gutters>
                        <v-col>
                            {{ Address.street }}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col>
                            {{ Address.zip }} {{ Address.city }}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col>
                            {{ Address.country }}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col>
                            <v-btn variant="text" small color="primary" class="px-0" style="text-transform: none;"
                                :href="Address?.mapslink" :target="'_blank'">
                                <v-icon size="13">mdi-map-marker</v-icon>
                                {{ $t('partner.job.show_on_map') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                <div v-else class="disabled--text">
                    {{ $t('partner.job.no_delivery_address') }}
                </div>
            </v-col>
            <v-col v-if="CustomerPerson" cols="auto" style="min-width: 150px; max-width: 230px;">
                <v-row no-gutters align="center">
                    <v-col cols="0">
                        {{ CustomerPerson.Name || "n/a" }}
                    </v-col>
                </v-row>
                <v-row no-gutters align="center" :class="CustomerPerson.Mobile ? undefined : 'disabled--text'">
                    <v-col cols="auto">
                        <v-icon size="13" class="pr-1">mdi-phone</v-icon>
                    </v-col>
                    <v-col cols="0">
                        {{ CustomerPerson.Mobile || "n/a" }}
                    </v-col>
                </v-row>
                <v-row no-gutters align="center" :class="CustomerPerson.Email ? undefined : 'disabled--text'">
                    <v-col cols="auto">
                        <v-icon size="13" class="pr-1">mdi-email</v-icon>
                    </v-col>
                    <v-col cols="0">
                        {{ CustomerPerson.Email || "n/a" }}
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-divider class="my-5"></v-divider>

        <div>
            <h4 v-if="isBatchJob" class="mb-5 section-title">{{ $t('partner.machine.machines') }}</h4>

            <div v-for="(machineJob, index) in InverseParent" :key="index" :id="machineJob.Machine.Id" class="pt-3">
                <div :style="isBatchJob ? 'border-left: 3px solid #e6e6e6;' : ''" :class="isBatchJob ? 'pl-4' : ''">
                    <MachineListItem :item="machineJob.Machine" @click="openMachineInfoDialog(machineJob.Machine)">
                        <template v-slot:actions>
                            <v-row no-gutters>
                                <!-- 
                                <v-btn icon>
                                    <v-icon color="green">mdi-file-delimited</v-icon>
                                </v-btn>
                                <v-btn icon>
                                    <v-icon color="green">mdi-file-clock</v-icon>
                                </v-btn>
                                <v-btn icon>
                                    <v-icon>mdi-folder-open</v-icon>
                                </v-btn>
                                -->
                                <v-btn variant="text" icon="mdi-information">
                                </v-btn>
                            </v-row>
                        </template>
                    </MachineListItem>
                    <MachineInfoDialog :opentrigger="machineDialogTrigger" :machine="machineDialogItem">
                    </MachineInfoDialog>


                    <h5 class="mb-2 pt-4 section-subtitle" :id="'comments-' + machineJob.Machine.Id">
                        {{ $t('partner.job.comments') }}
                    </h5>
                    <CommentField :machineJob="machineJob" fieldName="CustomerComment"
                        :label="$t('partner.job.customer_comment')" :readOnly="true">
                    </CommentField>
                    <CommentField :machineJob="machineJob" fieldName="TechnicianComment"
                        :label="$t('partner.job.technician_comment')" :readOnly="isFinalized">
                    </CommentField>
                    <CommentField :machineJob="machineJob" fieldName="InvoiceComment"
                        :label="$t('partner.job.invoice_comment')" :readOnly="isFinalized">
                    </CommentField>

                    <MachineCounters :machineid="machineJob.Machine.Id" :readonly="isFinalized" class="py-7"
                        :id="'counters-' + machineJob.Machine.Id">
                    </MachineCounters>

                    <OrderLines :machineJobId="machineJob.Id" :readonly="isFinalized" class="pt-7 mb-7"
                        :id="'articles-' + machineJob.Machine.Id">
                    </OrderLines>
                </div>

                <v-divider v-if="(index + 1) < (InverseParent.length)" class="my-7"
                    style="border-width: 1px; border-color: transparent; opacity: 0.5;">
                    <!-- var(--v-primary-base) -->
                </v-divider>
            </div>
        </div>
    </div>
</template>


<script>
import MachineCounters from "@/components/MachineCounters.vue";
import MachineListItem from "@/components/ListItems/MachineListItem.vue";
import OrderLines from "@/components/OrderLines.vue";
import MachineInfoDialog from "@/components/Dialogs/MachineInfoDialog.vue";
import CommentField from "./CommentField.vue";


export default {
    name: "JobReportImitation",
    props: {
        jobLoading: Boolean,
        job: Object,
    },
    components: {
        MachineCounters,
        MachineListItem,
        OrderLines,
        MachineInfoDialog,
        CommentField,
    },

    data() {
        return {
            machineDialogTrigger: 1,
            machineDialogItem: null,
        };
    },

    methods: {
        openMachineInfoDialog(machine) {
            this.machineDialogItem = machine;
            this.machineDialogTrigger++;
        },
    },

    computed: {
        Customer() {
            return this.job?.Customer;
        },
        Address() {
            if (this.job.CustomerDeliveryAdressStreet ||
                this.job.CustomerDeliveryAdressZip ||
                this.job.CustomerDeliveryAdressCity ||
                this.job.CustomerDeliveryAdressCountry) {
                var address = {
                    street: this.job.CustomerDeliveryAdressStreet,
                    zip: this.job.CustomerDeliveryAdressZip,
                    city: this.job.CustomerDeliveryAdressCity,
                    country: this.job.CustomerDeliveryAdressCountry
                }
                address.mapslink = `http://maps.google.com/?q=${address.street}, ${address.zip} ${address.city}, ${address.country}`;
                return address;
            }
            else {
                return null;
            }
        },
        CustomerPerson() {
            return this.job?.CustomerPerson
        },
        InverseParent() {
            return this.job?.InverseParent;
        },

        isBatchJob() {
            return this.job?.InverseParent.length > 1;
        },
        isFinalized() {
            return this.job?.JobStatus.Id >= 50;
        },
    },

    watch: {},
};
</script>


<style scoped>
.job-report {
    color: #1f1f1f;
}

.section-title {
    opacity: 0.85;
    font-size: 20px;
    font-weight: 600;
}

.section-subtitle {
    opacity: 0.85;
    font-size: 15px;
    font-weight: 600;
}

.v-textarea {
    font-size: 0.9em !important;
}

/* hides datatable empty text */
.v-data-table__empty-wrapper {
    display: none !important;
}
</style>